import React, { Component } from 'react';
import {Input} from 'reactstrap';



class Podcast extends Component {

    constructor(props) {
        super(props);
        this.state = {
            title: '',
            description: '',
            link: ''
        };

        this.subjectChange = this.subjectChange.bind(this);
        this.descriptionChange = this.descriptionChange.bind(this);
        this.addPodcast = this.addPodcast.bind(this);
        this.linkChange = this.linkChange.bind(this);

        // fetch('http://104.168.194.39/elearning/podcasts/', {
        //     method: 'post',
        //     body: JSON.stringify(
        //         {
        //             "method": "getList"
        //         }
        //     )
        // }).then(function(response) {
        //     return response.json();
        // }).then(function(data) {
        //     console.log(data);
        // }.bind(this));
    }

    subjectChange(event){
        this.setState({
            title: event.target.value
        });
    }

    descriptionChange(event){
        this.setState({
            description: event.target.value
        });
    }

    linkChange(event){
        this.setState({
            link: event.target.value
        });
    }

    addPodcast(){

        let r = window.confirm("Are you sure you want to add this Podcast?");
        if (r === true) {

            console.log(this.state.title);
            console.log(this.state.description);
            fetch('https://api.iondeveloper.com/admin/podcasts/', {
                method: 'post',
                body: JSON.stringify(
                    {
                        "method": "addPodcast",
                        "title": this.state.title,
                        "link": this.state.link,
                        "description": this.state.description
                    }
                )
            }).then(function(response) {
                return response.json();
            }).then(function(data) {
                console.log(data);
                if (data.success === true){
                    alert("Podcast is now in the app!");
                } else {
                    alert("Something went wrong, podcast wasn't added!");
                }

            });


        } else {

        }

    }

    render() {

        return (
            <div>
                <div className="email-container">
                    <h5>Add Podcast to App</h5>
                    <Input className="standard-input subject" type="text" placeholder="Podcast Title" value={this.state.title} onChange={this.subjectChange} ></Input>
                    <Input className="standard-input subject" type="text" placeholder="Podcast Description" value={this.state.description} onChange={this.descriptionChange} ></Input>
                    <Input className="standard-input subject" type="text" placeholder="Video Link" value={this.state.link} onChange={this.linkChange} ></Input>
                    <button type="button" className="form-submit small-button" onClick={this.addPodcast} >Add Podcast</button>
                </div>
            </div>
        );
    }

}


export default Podcast;


// WEBPACK FOOTER //
// ./src/components/shared/Podcast.js